module.exports = __webpack_public_path__ + "media/images/tahiti-4e76004132c70cff195aaa15d91bb92c.svg";